<div class="not-found" *ngIf="notFoundMessage">{{notFoundMessage}}</div>

<mat-card [style]="getTableStyle()">
  <mat-table [dataSource]="dataSource" matSort matSortActive="inceptionDate" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="brokerBranchName">
      <mat-header-cell *matHeaderCellDef> Broker Branch </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.brokerBranchName}}>{{row.brokerBranchName}}</div>
      </mat-cell>
    </ng-container>

    <!-- policy type -->
    <ng-container matColumnDef="claimTypeAsPolicyType"> 
      <mat-header-cell *matHeaderCellDef> Policy Type </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.claimType}}> {{row.claimType}}</div>
      </mat-cell>
    </ng-container>

     <!-- LOC -->
    <ng-container matColumnDef="levelOfCoverName">
      <mat-header-cell *matHeaderCellDef> Selected Cover </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.levelOfCoverName}}> {{row.levelOfCoverName}}</div>
      </mat-cell>
    </ng-container>

    <!-- Selected cover -->
    <!-- <ng-container matColumnDef="subProduct">
      <mat-header-cell *matHeaderCellDef> Selected Cover </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.subProduct}}> {{row.subProduct}}</div>
      </mat-cell>
    </ng-container> -->

     <!-- Policy Holder Name -->
    <ng-container matColumnDef="policyHolderName">
      <mat-header-cell *matHeaderCellDef> Policy Holder Name </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.policyHolderName}}> {{row.policyHolderName}}</div>
      </mat-cell>
    </ng-container>

    <!-- Policy Number -->
     <ng-container matColumnDef="certificateNumber">
      <mat-header-cell *matHeaderCellDef> Certificate Number </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.certificateNumber}}>{{row.certificateNumber}}</div>
      </mat-cell>
    </ng-container>

    <!-- Policy Inception Date -->
     <ng-container matColumnDef="inceptionDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Policy Inception Date </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis">{{row.inceptionDate |date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <!-- Policy Expiry Date -->
     <ng-container matColumnDef="expirationDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Policy Expiry Date </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis">{{row.expirationDate |date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <!-- claim type -->
    <ng-container matColumnDef="claimType"> 
      <mat-header-cell *matHeaderCellDef> Claim Type </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.claimType}}> {{row.claimType}}</div>
      </mat-cell>
    </ng-container>

    <!-- claim reference -->
    <ng-container matColumnDef="claimReference">
      <mat-header-cell *matHeaderCellDef> Claim Ref </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.claimReference}}>{{row.claimReference}}</div>
      </mat-cell>
    </ng-container>  

    <!-- Sub claim type -->
    <ng-container matColumnDef="subClaimType">
      <mat-header-cell *matHeaderCellDef> Sub Claim Type </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.subClaimType}}>{{row.subClaimType}}</div>
      </mat-cell>
    </ng-container> 

    <!-- Claim Opened Date -->
    <ng-container matColumnDef="claimOpenedDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Claim Opened </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis">{{row.claimOpenedDate |date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <!-- Hire Category -->
    <ng-container matColumnDef="hireCategory">
      <mat-header-cell *matHeaderCellDef> Hire Category </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.hireCategory}}>{{row.hireCategory}}</div>
      </mat-cell>
    </ng-container> 

    <!-- Days In Vehicle -->
    <ng-container matColumnDef="daysInVehicle">
      <mat-header-cell *matHeaderCellDef> Days In Vehicle </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.daysInVehicle}}>{{row.daysInVehicle}}</div>
      </mat-cell>
    </ng-container> 

    <!-- Days Invoiced -->
    <ng-container matColumnDef="daysInvoiced">
      <mat-header-cell *matHeaderCellDef> Days Invoiced </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.daysInvoiced}}>{{row.daysInvoiced}}</div>
      </mat-cell>
    </ng-container> 

    <!-- Total value paid () -->
    <ng-container matColumnDef="totalValuePaid">
      <mat-header-cell *matHeaderCellDef> Total Value Paid (Inc VAT) </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis"> {{row.totalValuePaid | currency:'GBP':'symbol'}}</div>
      </mat-cell>
    </ng-container>

     <!-- Rejected Reason -->
    <ng-container matColumnDef="rejectionReason">
      <mat-header-cell *matHeaderCellDef> Rejected Reason </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.rejectionReason}}>{{row.rejectionReason}}</div>
      </mat-cell>
    </ng-container> 

     <!-- Claim Status -->
    <ng-container matColumnDef="claimStatus">
      <mat-header-cell *matHeaderCellDef> Claim Status </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.claimStatus}}>{{row.claimStatus}}</div>
      </mat-cell>
    </ng-container> 
   
    <!-- Needs to removed -->
    <!-- <ng-container matColumnDef="paidValue">
      <mat-header-cell *matHeaderCellDef> Paid Value (Excluding VAT) </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis"> {{row.paidValue | currency:'GBP':'symbol'}}</div>
      </mat-cell>
    </ng-container> -->

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

  <div class="display-flex flex-direction-row footer">
    <div class="btn-group flex-50">
      <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
        matTooltip="Export to Excel" mat-raised-button color="primary" (click)="exportExcel()">
        Export to Excel
      </button>
      <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
        matTooltip="Export to CSV" mat-raised-button color="primary" (click)="exportCsv()">
        Export to CSV
      </button>
      <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
        matTooltip="Export to PDF" mat-raised-button color="primary" (click)="exportPdf()">
        Export to PDF
      </button>
    </div>

    <div class="paging flex-50">
      <mat-paginator [length]="totalRows" [pageIndex]="pagingConstant.pageIndex"
        [pageSize]="pagingConstant.pageSizeLarger" [pageSizeOptions]="pagingConstant.pageSizeOptionsLarger"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</mat-card>
